<!-- Price -->
<template>
  <div class="naim">
    <div class="naim-box">
      <h1 style="text-align: center; margin-bottom: 20px">
        智选云商助力手机门店营销落地方案
      </h1>
      <p
        style="
          margin-top: 20px;
          font-weight: 900;
          font-size: 20px;
          text-align: right;
          margin-bottom: 20px;
        "
      >
        合作热线：4000019839
      </p>
      <table id="tb_3">
        <thead>
          <tr align="center" bgcolor="#eff4fd">
            <th style="width: 130px">项目内容</th>
            <th style="width: 80px">原价</th>
            <th style="width: 90px">限时推广价</th>
            <th>包含内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>付费会员落地项目</td>
            <td>68888</td>
            <td>25888</td>
            <td style="text-align: left">
              <ol>
                <li>会员权益制作；</li>
                <li>员工落地考核方案；</li>
                <li>对外宣传物料元素提供；</li>
                <li>系统结合操作培训；</li>
                <li>全体员工的培训；</li>
                <li>上门现场指导2天，保证礼包项目的运营。</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>付费会员落地项目</td>
            <td>保障权益</td>
            <td>前三个月 销售占比率低于10%，退费50%</td>
            <td style="text-align: left">
              <span style="margin-left: 20px"
                >合作前提：企业全门店执行全部方案。</span
              >
            </td>
          </tr>
          <tr>
            <td>企业微信项目</td>
            <td>5888</td>
            <td>2999</td>
            <td style="text-align: left">
              <ol>
                <li>
                  帮助客户配置企业微信欢迎语和开单打通，将客户商城放在欢迎语里面，帮助客户商城推广，免费帮助客户更改10次；
                </li>
                <li>员工对外名片制作，进行圈粉使用；</li>
                <li>客户朋友圈上面装饰图制作，免费制作6次；</li>
                <li>
                  每个月帮助门店做2次直达客户的群发信息，内容和图片全部由智选云商完成，同时可以帮助门店免费制作24张转发图；
                </li>
                <li>考勤打卡配置，首次做好以后，还可以帮助客户更改6次；</li>
                <li>
                  汇报和申请流程18个，首次制作可以不用完，后面可以进行增减；
                </li>
                <li>新品上市宣传图免费做8张，企业微信全方位营销宣传；</li>
                <li>
                  帮助客户维护12个月，智选云商可以每2个月给客户出员工给客户沟通情况表。
                </li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>线上商城项目</td>
            <td>5588</td>
            <td>1999</td>
            <td style="text-align: left">
              <ol>
                <li>创建商城，对接系统；</li>
                <li>客服代为设置成门店指定店员；</li>
                <li>
                  首次完成上架基础商品不超过50个，包含详情页、价格和颜色，首批制作超过50个商品就使用12月服务期内的其他商品名额；
                </li>
                <li>
                  12月内额外再上架总商品60个，包含详情页，不限制更改商品价格次数，12个月服务期内商品名额用完，再安排上传每个商品收取7元服务费，一次最少购买20个数量；
                </li>
                <li>首页轮播图和导航图设计并上传</li>
                <li>增加5次营销活动；</li>
                <li>教会门店如何将单品生成海报对外宣传；</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td>优惠券获客、复购项目</td>
            <td>25888</td>
            <td>3599</td>
            <td style="text-align: left">
              <ol>
                <li>微信支付代开通与系统配置；</li>
                <li>优惠券制作5种；</li>
                <li>优惠券话术；</li>
                <li>上门现场指导1天，保证优惠券项目的运营；</li>
                <li>协助运营6个月，增加上下架优惠券5种。</li>
                <li>提供对外宣传物料模板</li>
              </ol>
            </td>
          </tr>
        </tbody>
        <tfoot class="table-tfoot">
          <tr>
            <td>金额合计</td>
            <td>106252</td>
            <td>34000元</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
 table {
    width: 100%;
    border: 1px solid #e6e9ed;
    border-spacing: 0;
    text-align: center;
    empty-cells: show;
    caption-side: right;
  }

  table tr th {
    border: 1px solid #e6e9ed;
    font-size: 18px;
    color: #6e7682;
    text-align: center;
    padding: 20px 10px;
    background-color: #eff4fd;
  }

  table tr td {
    border: 1px solid #e6e9ed;
    font-size: 16px;
    color: #6e7682;
    text-align: center;
    padding: 20px 10px;
  }

  .naim {
    width: 100%;
    height: calc(100vh);
    background-color: #e6e6e6;
    overflow: auto;
  }

  .naim-box {
    background-color: #ffffff;
    width: calc(60% - 44px);
    margin: 0px auto;
    padding: 80px;
    padding-top: 50px;
  }
  li {
    line-height: 25px;
    margin-left: 20px;
  }
</style>